import { X } from 'lucide-react';

import { cn } from '../../lib/cn.ts';

// Literal class names (Tailwind only generates classes it can see).
const DOT: Record<string, string> = {
  slate: 'bg-slate-500',
  red: 'bg-red-500',
  orange: 'bg-orange-500',
  amber: 'bg-amber-500',
  green: 'bg-green-500',
  teal: 'bg-teal-500',
  blue: 'bg-blue-500',
  violet: 'bg-violet-500',
  pink: 'bg-pink-500',
};

/** A tag: neutral chip (readable in both themes) with its color as a dot. */
export function TagChip({
  name,
  color,
  onRemove,
}: {
  name: string;
  color: string;
  onRemove?: () => void;
}) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-muted px-2.5 py-0.5 text-xs font-medium text-foreground">
      <span aria-hidden="true" className={cn('size-2 rounded-full', DOT[color] ?? DOT.blue)} />
      {name}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Quitar etiqueta ${name}`}
          className="-my-1 -mr-1.5 grid size-6 place-items-center rounded-full hover:bg-border"
        >
          <X className="size-3" aria-hidden="true" />
        </button>
      )}
    </span>
  );
}
